const translations = {
    en: {
        // Navigation
        nav: {
            dashboard: 'Dashboard',
            stockOps: 'Stock Operations',
            purchaseOrders: 'Orders (PO)',
            stockAudit: 'Stock Audit',
            history: 'History',
            settings: 'Settings',
            workspace: 'Workspace',
        },
        // Page subtitles
        pageSubtitles: {
            dashboard: 'Performance summary and current activities.',
            inventory: 'Manage stock in and out movements.',
            purchase_orders: 'Monitor and manage supplier orders.',
            stock_checks: 'Physical checks and inventory adjustments.',
            transactions: 'Complete record of inventory movements.',
            settings: 'Workspace configuration and product management.',
        },
        // Page titles
        pageTitles: {
            dashboard: 'Overview',
            inventory: 'Stock Operations',
            purchase_orders: 'Orders (PO)',
            stock_checks: 'Stock Audit',
            settings: 'System Settings',
            transactions: 'History',
        },
        // Dashboard
        dashboard: {
            inventoryValue: 'Inventory Value',
            thisMonth: 'this month',
            activeSKU: 'Active SKU',
            lowStock: 'Low Stock',
            critical: 'Critical',
            pendingPO: 'Pending PO',
            pending: 'Pending',
            activeAudit: 'Active Audit',
            active: 'Active',
            quickActions: 'Quick Actions',
            quickAccessMain: 'Quick access to main functions',
            stockIn: 'Stock In',
            stockOut: 'Stock Out',
            createPO: 'Create PO',
            startAudit: 'Start Audit',
            aiInsights: 'AI Insights',
            smartAnalysis: 'Smart analysis',
            generateAnalysis: 'Generate Stock Analysis',
            forecastInventory: 'Forecast Inventory',
            stockOut30Days: 'Stock Out (30 Days)',
            todayActivity: "Today's Activity",
            inLabel: 'IN',
            outLabel: 'OUT',
            unit: 'unit',
            transactions: 'Transactions',
            systemStats: 'System Statistics',
            totalSKU: 'Total SKU',
            totalTransactions: 'Total Transactions',
            productCategories: 'Product Categories',
            activeSuppliers: 'Active Suppliers',
            todayTransactions: "Today's Transactions",
            systemOnline: 'System Online',
            viewAll: 'View All →',
            recentActivity: 'Recent Activity',
            activity: 'Activity',
            noActivityRecorded: 'No activity recorded yet',
            noActivityRecordedShort: 'No activity recorded',
            criticalStock: 'Critical Stock',
            manageAllLowStock: 'Manage All Low Stock →',
            allGood: 'All Good!',
            noProductsBelowMin: 'No products below minimum level',
            recentPriceLog: 'Recent Price Log',
            noPriceChanges: 'No price changes',
            noCompletedPO: 'No completed PO',
            stockLabel: 'Stock',
        },
        // Inventory / Stock Operations
        inventory: {
            stockIn: 'Stock In',
            stockOut: 'Stock Out',
            bulkStockOut: 'Bulk Stock Out',
            searchProduct: 'Search product...',
            allCategories: 'All Categories',
            addProduct: 'Add Product',
            inStock: 'In Stock',
            minLevel: 'Min Level',
            in: 'In',
            out: 'Out',
            priceLog: 'Price Log',
            editProduct: 'Edit Product',
            deleteProduct: 'Delete Product',
            deleteProductConfirm: 'Delete this item?',
            viewFullImage: 'Click to view full image',
            bulkMode: 'Bulk Mode',
            exitBulkMode: 'Exit',
            bulkProof: 'Proof Document',
            dragDropImage: 'Drag & drop image here',
            orClickToUpload: 'or click to upload',
            imageUploaded: 'Image uploaded',
            changeImage: 'Change',
            bulkSelectProduct: 'Select product...',
            bulkSearchProduct: 'Search product, SKU or category...',
            bulkNoResults: 'No products found',
            qty: 'Qty',
            add: 'Add',
            itemsSelected: 'items selected',
            confirmBulkOut: 'Confirm Bulk Out',
            product: 'Product',
            quantity: 'Quantity',
            unitLabel: 'Unit',
            selectItem: 'Select Item...',
            searchProductSKU: 'Search product, SKU or category...',
            noProductFound: 'No products found',
            reason: 'Reason',
            selectReason: 'Select reason',
            dailyUsage: 'Daily Usage',
            damaged: 'Damaged',
            lost: 'Lost',
            returned: 'Returned',
            transfer: 'Transfer',
            other: 'Other',
            invoiceRef: 'Invoice No. / Purpose',
            personInCharge: 'Person In Charge',
            picName: 'Person In Charge Name',
            proofUpload: 'Upload Receipt/Proof',
            proofRequired: 'Proof Required',
            submit: 'Submit',
            uploadImageOnly: 'Please upload image files only',
            pleaseUploadProof: 'Please upload proof document/image',
            insufficientStock: 'Insufficient stock',
            stockUpdated: 'Stock updated',
            noItemsAdded: 'No items added',
            pleaseSelectProduct: 'Please select a product',
            invalidQty: 'Invalid quantity',
            bulkOutError: 'Error during bulk out',
            lowStockAlert: 'Low Stock',
            noProductsFound: 'No products found.',
            backToList: 'Back to List',
            addItem: 'Add Item',
            selectFromInventory: 'Select product from your inventory',
            searchAndSelectItem: 'Search & select item...',
            itemDetails: 'Item Details',
            noItemsYet: 'No items added yet',
            selectFromDropdown: 'Select product from the dropdown above',
            exitDetails: 'Exit Details',
            additionalInfoOptional: 'Additional Information (Optional)',
            totalItems: 'Total Items',
            totalUnitsOut: 'Total Units Out',
            confirmStockIn: 'Confirm In',
            confirmStockOut: 'Confirm Out',
            stockQtyManagedNote: 'Stock quantities and locations are managed through the',
            stockOpsTab: 'Stock Operations',
            stockQtyManagedNote2: 'tab to ensure proper audit trail.',
            selectItemStockIn: 'Select Item for Stock In',
            selectItemStockOut: 'Select Item for Stock Out',
            searchProductSKUShort: 'Search product name or SKU...',
            noItemFound: 'No item found',
            priceChangedFrom: 'Price changed from RM',
            priceChangedTo: 'to RM',
        },
        // Purchase Orders
        po: {
            backToList: 'Back to List',
            newPO: 'New PO',
            editPO: 'Edit PO',
            itemDescription: 'Item Description',
            sku: 'SKU',
            qtyLabel: 'Qty',
            unitLabel: 'Unit',
            unitPrice: 'Unit Price',
            amount: 'Amount',
            totalLabel: 'Total',
            grandTotal: 'Grand Total',
            addItem: 'Add Item',
            selectItem: 'Select Item...',
            searchProduct: 'Search product, SKU or category...',
            noProductFound: 'No products found',
            supplier: 'Supplier',
            selectSupplier: 'Select Supplier',
            addNewSupplier: 'Add New Supplier',
            paymentTerm: 'Payment Term',
            notes: 'Notes',
            notesPlaceholder: 'Additional notes or special instructions...',
            createPO: 'Create Purchase Order',
            updatePO: 'Update Purchase Order',
            deleteItem: 'Delete Item',
            allSuppliers: 'All Suppliers',
            allStatuses: 'All Statuses',
            incomplete: 'Incomplete',
            completed: 'Completed',
            cancelled: 'Cancelled',
            allTime: 'All Time',
            today: 'Today',
            yesterday: 'Yesterday',
            thisWeek: 'This Week',
            lastWeek: 'Last Week',
            thisMonth: 'This Month',
            lastMonth: 'Last Month',
            customRange: 'Custom Range',
            listView: 'List View',
            calendarView: 'Calendar View',
            filterActive: 'active filter',
            noItems: 'No items',
            poNumber: 'PO Number',
            date: 'Date',
            status: 'Status',
            items: 'items',
            cancelPO: 'Cancel PO',
            cancelPOConfirm: "Are you sure you want to cancel this PO? Status will be changed to 'Cancelled'.",
            deletePO: 'Delete PO',
            deletePOConfirm: 'Are you sure you want to permanently delete this PO? This action cannot be undone.',
            downloadExcel: 'Download Excel',
            printPO: 'Print',
            receivePO: 'Receive Goods',
            receiveTitle: 'Goods Receiving Confirmation',
            poCreated: 'Purchase Order Created',
            poUpdated: 'Purchase Order Updated',
            poCompleted: 'Purchase Order Completed',
            poCreateError: 'Error creating PO',
            poUpdateError: 'Error updating PO',
            poCancelError: 'Error cancelling PO',
            poDeleteError: 'Error deleting PO',
            matched: 'Matched',
            matchedInfo: 'All received quantities match the ordered quantities. No discrepancies found.',
            discrepancyInfo: 'Discrepancies detected. Please review the quantities below.',
            received: 'Received',
            ordered: 'Ordered',
            diff: 'Diff',
            confirmComplete: 'Confirm & Complete PO',
            systemQty: 'System',
            actualQty: 'Actual',
            calToday: 'Today',
            calLastMonth: 'Last Month',
            calNextMonth: 'Next Month',
            noPO: 'No PO',
            noPOFound: 'No purchase orders found.',
            orderItems: 'Order Items',
            totalColon: 'Total:',
            orderCompletedDiscrepancy: 'Order completed with quantity discrepancies.',
            stockAddedSuccessfully: 'Stock has been successfully added to inventory.',
            receiveAllFullReset: 'Receive All Full (Reset)',
            clearAll: 'Clear All',
            confirmUpdateStock: 'Confirm & Update Stock',
            errorLabel: 'Error',
            errorCancelPO: 'Error cancelling PO',
            errorDeletePO: 'Error deleting PO',
            poNoLabel: 'PO No.:',
            dateLabel: 'Date:',
            paymentTermLabel: 'Payment Term:',
            statusLabel: 'Status:',
            priceRM: 'Price (RM)',
        },
        // Stock Check / Audit
        stockCheck: {
            startNewAudit: 'Start New Audit',
            auditorName: 'Auditor Name',
            auditNotes: 'Audit Notes',
            searchItem: 'Search Item or SKU to check...',
            system: 'System',
            actual: 'Actual',
            match: 'Match',
            excess: 'Excess',
            shortage: 'Shortage',
            totalItems: 'Total Items',
            checked: 'Checked',
            matched: 'Matched',
            discrepancies: 'Discrepancies',
            completeAudit: 'Complete Audit',
            generateReport: 'Generate Report',
            auditStarted: 'Audit Started',
            auditCompleted: 'Audit Completed & Stock Adjusted',
            auditError: 'Error during audit',
            completeAuditError: 'Error completing audit',
            confirmEndAudit: 'Confirm End Audit',
            endAuditWarning: 'Items not checked will be counted as "Matched" (no change to stock).',
            searchAuditor: 'Search Auditor or Notes...',
            allTime: 'All Time',
            today: 'Today',
            yesterday: 'Yesterday',
            thisWeek: 'This Week',
            lastWeek: 'Last Week',
            thisMonth: 'This Month',
            lastMonth: 'Last Month',
            customRange: 'Custom Range',
            inProgress: 'In Progress',
            completed: 'COMPLETED',
            complete: 'Complete',
            auditProgress: 'Audit Progress',
            progress: 'Progress',
            continueAudit: 'Continue Audit',
            auditStock: 'Stock Audit',
            confirm: 'Confirm',
            allStatuses: 'All Statuses',
            noAuditFound: 'No Audit Found',
            noStockAudit: 'No Stock Audit',
            startNewAuditDesc: 'Start a new stock audit to track your inventory.',
            startNewAuditBtn: 'Start New Audit',
            completionDate: 'Completion Date',
            auditDate: 'Audit Date',
            officerOnDuty: 'Officer On Duty Name',
            additionalNotes: 'Additional notes...',
            starting: 'Starting...',
            startAuditBtn: 'Start Audit',
            auditInfoNote: 'The system will record current stock levels for comparison. Make sure all pending transactions are completed.',
            adjustmentWarning: 'Attention: Stock Adjustments Will Be Made',
            allItemsMatch: 'All Items Match',
            noAdjustmentNeeded: 'No stock adjustment needed',
            confirmEndAuditBtn: 'Confirm & End Audit',
            auditStockReport: 'Stock Audit Report',
            variance: 'Variance',
            physical: 'Physical',
            adjustment: 'Adjustment',
            needsAdjustment: 'Needs Adjustment',
            itemsToAdjust: 'Items To Be Adjusted',
            adjustmentDescription: 'The system will adjust stock quantities for items with discrepancies. This action cannot be undone.',
            auditNo: 'Audit No.',
            auditor: 'Auditor',
        },
        // History / Transactions
        history: {
            searchItemReason: 'Search item, Reason, User, or PIC...',
            allTime: 'All Time',
            today: 'Today',
            yesterday: 'Yesterday',
            thisWeek: 'This Week',
            lastWeek: 'Last Week',
            thisMonth: 'This Month',
            lastMonth: 'Last Month',
            selectDateRange: 'Select Date Range',
            allTypes: 'All Types',
            stockIn: 'Stock In',
            stockOut: 'Stock Out',
            adjustment: 'Adjustment',
            transactionDetails: 'Transaction Details',
            downloadReport: 'Download Report',
            burstReport: 'Burst Report',
            monthlyBurstReport: 'Monthly Burst Report',
            viewProof: 'View Proof',
            noTransactions: 'No transactions found.',
            invoiceRef: 'Invoice/Ref',
            pic: 'PIC',
            proof: 'Proof',
            dateCol: 'Date',
            typeCol: 'Type',
            userCol: 'User',
            noTransactionsFound: 'No transactions found',
            errorFetchingLog: 'Error fetching transaction log',
            errorFetchingDetail: 'Error fetching transaction details',
            dateTime: 'Date & Time',
            additionalInfoProof: 'Additional Information & Proof',
            picNameLabel: 'PIC Name',
            supplierLabel: 'Supplier: ',
            stockOutHeading: 'Stock Out',
            burstLimit: 'Burst Limit',
            burstCount: 'Burst Count',
            noBurstViolations: 'No Burst Limit Violations',
            allItemsWithinLimit: 'All items are within the monthly out limit.',
            selectMonth: 'SELECT MONTH',
            itemsExceededLimit: 'Items Exceeded Limit',
            exceededLimit: 'Exceeded Limit',
            percentage: 'Percentage',
            stockIn: 'STOCK IN',
            stockOut: 'STOCK OUT',
            poReceived: 'PO RECEIVED',
            auditAdjustment: 'AUDIT ADJUSTMENT',
            recordedBy: 'Recorded By',
            picName: 'PIC Name',
            contactNo: 'Contact No.',
            auditorLabel: 'Auditor: ',
            auditId: 'Audit ID: ',
            burstReportDownloaded: 'Burst Report downloaded',
            categoryCol: 'Category',
            transactionLog: 'Transaction Log',
            burstReportTab: 'Monthly Burst Report',
        },
        // Settings
        settings: {
            projectDetails: 'Workspace Details',
            skuManagement: 'SKU Management',
            supplierManagement: 'Supplier Management',
            companyInfo: 'Company Information',
            companyName: 'Company Name',
            companySsm: 'SSM No.',
            companyPhone: 'Phone',
            companyEmail: 'Email',
            companyLogo: 'Company Logo',
            uploadLogo: 'Upload Logo',
            changeLogo: 'Change Logo',
            addressLine1: 'Address Line 1',
            addressLine2: 'Address Line 2 (Optional)',
            postcode: 'Postcode',
            state: 'State',
            selectState: 'Select State',
            warehouseInfo: 'Warehouse Information',
            warehouseName: 'Warehouse Name',
            warehousePIC: 'Person In Charge',
            warehouseAddress: 'Warehouse Address',
            projectInfo: 'Workspace Information',
            projectName: 'Workspace Name',
            projectDesc: 'Workspace Description',
            projectType: 'Workspace Type',
            saveChanges: 'Save Changes',
            saveConfirm: 'Are you sure you want to save these workspace details?',
            saveSuccess: 'Workspace details updated successfully',
            saveError: 'Error saving workspace details',
            deleteProject: 'Delete Workspace',
            deleteConfirmTitle: 'Final Confirmation',
            deleteConfirmMsg: 'type the workspace name to confirm deletion. This action is irreversible.',
            typeToConfirm: 'Type workspace name to confirm',
            editSupplier: 'Edit Supplier',
            addSupplier: 'Add Supplier',
            supplierName: 'Supplier Name',
            supplierPhone: 'Phone',
            supplierEmail: 'Email',
            supplierAddress: 'Address',
            supplierUpdated: 'Supplier updated',
            supplierAdded: 'Supplier added',
            supplierError: 'Error saving supplier',
            categoryManagement: 'Category Management',
            addCategory: 'Add Category',
            categoryAdded: 'Category added',
            categoryDeleted: 'Category deleted',
            deleteCategory: 'Delete Category',
            deleteCategoryConfirm: 'Delete category',
            // Workspace Details page additions
            companyDetails: 'Company Details',
            displayedOnInvoicePO: 'Will be displayed on invoices and POs.',
            registeredCompanyName: 'REGISTERED COMPANY NAME',
            companyLogoLabel: 'COMPANY LOGO',
            logoDisplayedOnPDF: 'Logo will be displayed on PO PDF and Stock Audit Reports.',
            deleteCompanyLogo: 'Delete Company Logo',
            confirmDeleteLogo: 'Are you sure you want to delete this company logo?',
            logoDeleted: 'Company logo deleted',
            failedDeleteLogo: 'Failed to delete logo',
            logoUpdated: 'Company logo updated',
            failedUploadLogo: 'Failed to upload logo',
            formatMaxSize: 'Format: PNG, JPG, GIF (Max 2MB)',
            recommendedSize: 'Recommended: 200x200px or higher',
            companySSMNo: 'COMPANY SSM NO.',
            officialPhone: 'OFFICIAL PHONE NO.',
            officialEmail: 'OFFICIAL EMAIL',
            websiteLabel: 'WEBSITE',
            mailingAddress: 'COMPANY MAILING ADDRESS',
            line2Optional: 'Line 2 (Optional)',
            postcodeLabel: 'Postcode',
            warehouseInfoTitle: 'Warehouse Information',
            warehouseNameAddress: 'Name and address of operations/delivery location.',
            warehouseNameLabel: 'WAREHOUSE NAME',
            warehousePICName: 'WAREHOUSE PIC NAME',
            picPhoneNo: 'PIC PHONE NO.',
            picEmailLabel: 'PIC EMAIL',
            warehouseDeliveryAddress: 'WAREHOUSE ADDRESS (DELIVERY)',
            companyMailingAddress: 'COMPANY MAILING ADDRESS',
            projectIdentity: 'Workspace Identity',
            projectNameIcon: 'Workspace name and icon for dashboard.',
            projectNameLabel: 'WORKSPACE NAME',
            descriptionLabel: 'DESCRIPTION',
            projectIconLabel: 'WORKSPACE ICON',
            chooseIconDesc: 'Choose an icon that represents your workspace. This icon will be displayed on the main page.',
            saveProjectDetails: 'Save Workspace Details',
            imageTooLarge: 'Image size too large. Maximum 2MB.',
            // SKU Management additions
            searchProductPlaceholder: 'Search product...',
            categoryBtn: 'Category',
            newProduct: 'New Product',
            productCol: 'PRODUCT',
            categoryCol: 'CATEGORY',
            priceCol: 'PRICE',
            stockCol: 'STOCK',
            burstLimitMonthly: 'BURST LIMIT (MONTHLY)',
            actionsCol: 'ACTIONS',
            priceUp: 'Price up',
            priceDown: 'Price down',
            lowStockTooltip: 'Low Stock',
            priceLogTooltip: 'Price Log',
            editProductTooltip: 'Edit Product',
            deleteProductTooltip: 'Delete Product',
            noProductsFound: 'No products found.',
            // Supplier Management additions
            companyNameCol: 'Company Name',
            picCol: 'PIC',
            contactCol: 'Contact',
            addressColHeader: 'Address',
            deleteConfirmQ: 'Delete?',
            deleteSupplierConfirm: 'Delete this supplier?',
            noSuppliers: 'No suppliers.',
            emailLabel: 'Email',
            updateBtn: 'Update',
            saveBtn: 'Save',
            // Category modal
            newCategoryPlaceholder: 'New Category...',
            addBtn: 'Add',
            noCategoriesYet: 'No categories.',
            deleteCategoryQ: 'Delete category',
            // Supplier modal
            picNameLabel: 'PIC Name',
            picPhoneLabel: 'PIC Phone',
            line1Placeholder: 'Line 1',
            line2Placeholder: 'Line 2 (Optional)',
            manageCategory: 'Manage Categories',
        },
        // Auth
        auth: {
            login: 'Log In',
            logout: 'Log Out',
            logoutConfirm: 'Are you sure you want to log out?',
            email: 'Email Address',
            emailPlaceholder: 'name@company.com',
            password: 'Password',
            rememberMe: 'Remember me',
            forgotPassword: 'Forgot password?',
            resetPassword: 'Reset Password',
            resetYourPassword: 'Reset Your Password',
            sendVerificationCode: 'Send Verification Code',
            verificationCode: 'Verification Code',
            enterCode: 'Enter 6-digit code',
            newPassword: 'New Password',
            backToLogin: 'Back to login',
            codeSent: 'Verification code has been sent to your email. Please check your inbox.',
            passwordReset: 'Password successfully updated! Please log in with your new password.',
            loginFailed: 'Log In Failed',
            resetFailed: 'Reset Password Failed',
            networkError: 'Network or server error.',
            noResponse: 'No response from server. Please check your internet connection.',
            serverError: 'Server Error',
            subtitle: 'The Inventory Management Software Tailored for Your Warehouse',
            userProfile: 'User Profile',
            language: 'Language',
            fullName: 'Full Name',
            yourPassword: 'Your password',
            profileUpdated: 'Profile updated',
            userManual: 'User Manual',
            userManualDesc: 'Open complete system usage manual (can print/save PDF)',
            // Profile modal additions
            uploadPhoto: 'Upload Photo',
            imageFormatMax: 'Format: JPG, PNG, GIF (Max 2MB)',
            fullNameLabel: 'FULL NAME',
            emailAddressLabel: 'EMAIL ADDRESS',
            emailCannotChange: 'Email cannot be changed',
            changePassword: 'Change Password',
            newPasswordOptional: 'NEW PASSWORD (OPTIONAL)',
            leaveBlankPassword: 'Leave blank if you do not want to change password',
            confirmPasswordLabel: 'CONFIRM PASSWORD',
            accessLevelLabel: 'YOUR ACCESS LEVEL',
            superAdminGlobal: 'Super Admin (Global)',
            projectUser: 'Workspace User',
            cannotChangeAccess: 'You cannot change your own access level',
            processing: 'Processing...',
        },
        // Common
        common: {
            save: 'Save',
            cancel: 'Cancel',
            delete: 'Delete',
            edit: 'Edit',
            search: 'Search',
            add: 'Add',
            close: 'Close',
            confirm: 'Confirm',
            last: 'Last',
            previous: 'Previous',
            next: 'Next',
            yes: 'Yes',
            no: 'No',
            loading: 'Loading data...',
            error: 'Error',
            success: 'Success',
            noData: 'No data found',
            actions: 'Actions',
            name: 'Name',
            created: 'Created',
            from: 'From',
            to: 'To',
            all: 'All',
            type: 'Type',
            print: 'Print',
            download: 'Download',
            deleteConfirm: 'Are you sure?',
            projectCreated: 'Workspace created',
            projectDeleted: 'Workspace deleted successfully',
            projectDeleteError: 'Error deleting workspace',
            productSaved: 'Product saved',
            productSaveError: 'Error saving product',
            userCreated: 'User created',
            userUpdated: 'User updated',
            userDeleted: 'User deleted',
            deleteUser: 'Delete User',
            deleteUserConfirm: 'Are you sure you want to delete this user?',
            mainWarehouse: 'Main Warehouse',
            yesConfirm: 'Yes, Confirm',
            processing: 'Processing...',
            reset: 'Reset',
            noDescription: 'No workspace description.',
            errorVerifyingPassword: 'Error verifying password',
            insufficientStockFor: 'Insufficient stock for',
        },
        // Workspace Selection
        projects: {
            welcome: 'Welcome',
            selectProject: 'Select a workspace to start managing your inventory.',
            newProject: 'New Workspace',
            manageUsers: 'Manage Users',
            userManagement: 'User Management',
            manageAccess: 'Manage system user access and roles',
            createFirstProject: 'Create First Workspace',
            startManaging: 'Start managing your stock now',
            noProjectsAssigned: 'No Workspaces Assigned',
            contactSuperAdmin: 'Contact Super Admin for workspace access',
            createNewProject: 'Create New Workspace',
            briefDescription: 'Brief workspace description...',
            createProject: 'Create Workspace',
            description: 'Description',
            exampleWarehouse: 'E.g.: Petaling Jaya Warehouse',
        },
        // Reports / Excel / PDF
        reports: {
            generatedBy: 'Generated by ENHIVE on',
            generatedByMs: 'Generated by ENHIVE on',
            purchaseOrder: 'PURCHASE ORDER',
            vendorSupplier: 'VENDOR (SUPPLIER)',
            shipTo: 'SHIP TO',
            subtotal: 'SUBTOTAL',
            grandTotal: 'GRAND TOTAL (RM)',
            termsTitle: 'Terms & Conditions',
            term1: 'Goods once sold will not be taken back or exchanged',
            term2: 'Goods remain the property of the vendor till fully paid',
            term3: 'Delivery must be made within the time specified',
            term4Prefix: 'All disputes are subject to',
            term4Suffix: 'jurisdiction only',
            term5Prefix: 'Payment terms:',
            term5Default: '30 days from invoice date',
            computerGenerated: 'This is a computer-generated document. No signature is required.',
            notesInstructions: 'NOTES / INSTRUCTIONS',
            noAdditionalNotes: 'No additional notes.',
            auditReportTitle: 'STOCK AUDIT REPORT',
            auditNo: 'Audit No.',
            dateLabel: 'Date',
            auditor: 'Auditor',
            statusLabel: 'Status',
            completedStatus: 'Completed',
            inProgressStatus: 'In Progress',
            totalItems: 'Total Items',
            matchedLabel: 'Matched',
            discrepanciesLabel: 'Discrepancies',
            itemsList: 'Items List',
            productName: 'Product Name',
            systemQty: 'System',
            physicalQty: 'Physical',
            difference: 'Difference',
            auditNotes: 'Audit Notes',
            autoGenerated: 'This document is automatically generated. No signature is required.',
            burstLabel: 'Burst Count',
            noLabel: 'No.',
            skuLabel: 'SKU',
            systemStockLabel: 'System Stock',
            physicalStockLabel: 'Physical Stock',
            unitLabel: 'Unit',
            differenceLabel: 'Difference',
            statusColLabel: 'Status',
        },
        // Item Modal
        itemModal: {
            updateProduct: 'Update Product',
            addNewProduct: 'Add New Product',
            productName: 'Product Name',
            sku: 'SKU Code',
            category: 'Category',
            selectCategory: 'Select Category',
            unit: 'Unit',
            currentStock: 'Current Stock',
            minStock: 'Min. Stock Level',
            costPrice: 'Cost Price (RM)',
            productImage: 'Product Image',
        },
        // Stock Modal
        stockModal: {
            stockInTitle: 'Stock In',
            stockOutTitle: 'Stock Out',
        },
        // User Management
        userMgmt: {
            title: 'User Management',
            subtitle: 'Manage system user access and roles',
            addUser: 'Add User',
            editUser: 'Edit User',
            isSuperAdmin: 'Super Admin',
            normalUser: 'Normal User',
            superAdminAccess: 'Full access to all features',
            limitedAccess: 'Access based on assigned permissions',
            permissions: 'Permissions',
            hideFinancials: 'Hide Financial Data',
            roleDescription: 'Role Description',
            passwordPlaceholder: 'Your password',
            // New additions
            editUserDetails: 'Edit User Details',
            createNewUser: 'Create New User',
            uploadPhoto: 'Upload Photo',
            imageFormatMax: 'Format: JPG, PNG, GIF (Max 2MB)',
            fullNameLabel: 'FULL NAME',
            emailAddressLabel: 'EMAIL ADDRESS',
            passwordLabel: 'PASSWORD',
            keepExistingPassword: 'Leave blank to keep existing password',
            accessLevel: 'ACCESS LEVEL',
            projectLevel: 'Workspace',
            selectProjectRole: 'Choose specific workspace and role',
            fullAccessAllSystems: 'Full access to all workspaces & system',
            superAdminFullAccess: 'Super Admin has full access to:',
            selectProjectRoleLabel: 'SELECT WORKSPACE & ROLE',
            roleGuide: 'Role Guide:',
            adminRoleDesc: 'Full access except user/workspace management',
            supervisorRoleDesc: 'Daily operations without workspace settings',
            staffRoleDesc: 'Stock Operations (Stock Out only)',
            hideFinancialInfo: 'Hide Financial Information',
            userCannotViewPrices: 'User will not be able to view prices or costs.',
            accountStatus: 'ACCOUNT STATUS',
            activeStatus: 'Active',
            inactiveStatus: 'Inactive',
            updateUser: 'Update User',
            createUser: 'Create User',
            noProjectsAvailable: 'No workspaces available',
            imageTooLarge: 'Image size too large. Maximum 2MB.',
            createNewUserBtn: 'Create New User',
            projectAccessCol: 'Workspace Access',
            allProjectsGlobal: 'All Workspaces (Global)',
            noAccess: 'No access',
            deleteTooltip: 'Delete',
            noUsersFound: 'No users found',
            clickCreateNewUser: 'Click "Create New User" to start',
            // Role descriptions
            superAdminDesc: 'Full access to all workspaces and system settings',
            superAdminFeatures: 'Manage users,Create/delete workspaces,Access all modules,View all financial data',
            adminDesc: 'Full access to workspace modules, except user and workspace management',
            adminFeatures: 'Dashboard,Stock Operations,PO,Stock Audit,History,Workspace Settings',
            supervisorDesc: 'Access to daily operations, without workspace settings',
            supervisorFeatures: 'Dashboard,Stock Operations,PO,Stock Audit,History',
            staffDesc: 'Limited access to Stock Operations only (Stock Out)',
            staffFeatures: 'Stock Operations (Stock Out only)',
        },
        // Confirm modal
        confirmModal: {
            confirmAction: 'Confirm Action',
        },
        // Supplier modal fields
        supplierModal: {
            name: 'Company Name',
            contactPerson: 'Contact Person',
            phone: 'Phone',
            email: 'Email',
            addressLine1: 'Address Line 1',
            addressLine2: 'Address Line 2',
            postcode: 'Postcode',
            state: 'State',
            selectState: 'Select State',
        },
        // Price Log
        priceLog: {
            title: 'Price History',
            costPrice: 'Cost Price',
            date: 'Date',
            noData: 'No price history available',
            currentPrice: 'Current Price: RM',
            priceChangeHistory: 'Price Change History',
            noPriceChanges: 'No price changes recorded',
        },
        // Receive PO Modal
        receivePOModal: {
            matchedMsg: 'All received quantities match the ordered quantities. No discrepancies found.',
            discrepancyMsg: 'Discrepancies detected. Please review the quantities below.',
        },
        // AI Insights
        aiInsights: {
            textCopied: 'Text copied successfully!',
            failedToCopy: 'Failed to copy text',
            projectLabel: 'Workspace:',
            dateLabel: 'Date:',
            noContent: 'No content',
            noContentAvailable: 'No content available.',
            copyBtn: 'Copy',
            closeBtn: 'Close',
        },
        // Delete Workspace Modal
        deleteProjectModal: {
            title: 'Delete Workspace',
            warningMsg: 'All inventory data, transactions, and reports will be permanently deleted.',
            dataToBeDeleted: 'Data that will be deleted:',
            allProducts: 'All products and stock',
            purchaseOrders: 'Purchase orders (PO)',
            transactionHistory: 'Transaction history',
            confirmWithPassword: 'Confirm by entering your password:',
            deleteProjectBtn: 'Delete Workspace',
        },
        // Bulk Confirm Modal
        bulkConfirm: {
            title: 'Confirm Bulk Out',
            itemList: 'Item List',
        },
    },
    ms: {
        // Navigation
        nav: {
            dashboard: 'Dashboard',
            stockOps: 'Operasi Stok',
            purchaseOrders: 'Pesanan (PO)',
            stockAudit: 'Audit Stok',
            history: 'Sejarah',
            settings: 'Tetapan',
            workspace: 'Ruang Kerja',
        },
        // Page subtitles
        pageSubtitles: {
            dashboard: 'Ringkasan prestasi dan aktiviti semasa.',
            inventory: 'Urus pergerakan masuk dan keluar stok.',
            purchase_orders: 'Pantau dan urus pesanan kepada pembekal.',
            stock_checks: 'Semakan fizikal dan pelarasan inventori.',
            transactions: 'Rekod lengkap pergerakan inventori.',
            settings: 'Konfigurasi ruang kerja dan pengurusan produk.',
        },
        // Page titles
        pageTitles: {
            dashboard: 'Gambaran Keseluruhan',
            inventory: 'Operasi Stok',
            purchase_orders: 'Pesanan (PO)',
            stock_checks: 'Audit Stok',
            settings: 'Tetapan Sistem',
            transactions: 'Sejarah',
        },
        // Dashboard
        dashboard: {
            inventoryValue: 'Nilai Inventori',
            thisMonth: 'bulan ini',
            activeSKU: 'SKU Aktif',
            lowStock: 'Stok Rendah',
            critical: 'Kritikal',
            pendingPO: 'PO Tertunggak',
            pending: 'Menunggu',
            activeAudit: 'Audit Berlangsung',
            active: 'Aktif',
            quickActions: 'Tindakan Pantas',
            quickAccessMain: 'Akses cepat fungsi utama',
            stockIn: 'Stok Masuk',
            stockOut: 'Stok Keluar',
            createPO: 'Cipta PO',
            startAudit: 'Mula Audit',
            aiInsights: 'Pandangan AI',
            smartAnalysis: 'Analisis pintar',
            generateAnalysis: 'Jana Stok Analisa',
            forecastInventory: 'Forecast Inventori',
            stockOut30Days: 'Stok Keluar (30 Hari)',
            todayActivity: 'Aktiviti Hari Ini',
            inLabel: 'MASUK',
            outLabel: 'KELUAR',
            unit: 'unit',
            transactions: 'Transaksi',
            systemStats: 'Statistik Sistem',
            totalSKU: 'Jumlah SKU',
            totalTransactions: 'Jumlah Transaksi',
            productCategories: 'Kategori Produk',
            activeSuppliers: 'Pembekal Aktif',
            todayTransactions: 'Transaksi Hari Ini',
            systemOnline: 'Sistem Online',
            viewAll: 'Lihat Semua →',
            recentActivity: 'Aktiviti Terkini',
            activity: 'Aktiviti',
            noActivityRecorded: 'Tiada aktiviti direkodkan lagi',
            noActivityRecordedShort: 'Tiada aktiviti direkodkan',
            criticalStock: 'Stok Kritikal',
            manageAllLowStock: 'Urus Semua Stok Rendah →',
            allGood: 'Semua Baik!',
            noProductsBelowMin: 'Tiada produk di bawah tahap minimum',
            recentPriceLog: 'Log Harga Terkini',
            noPriceChanges: 'Tiada perubahan harga',
            noCompletedPO: 'Tiada PO selesai',
            stockLabel: 'Stok',
        },
        // Inventory / Stock Operations
        inventory: {
            stockIn: 'Stok Masuk',
            stockOut: 'Stok Keluar',
            bulkStockOut: 'Keluar Pukal',
            searchProduct: 'Cari produk...',
            allCategories: 'Semua Kategori',
            addProduct: 'Tambah Produk',
            inStock: 'Stok',
            minLevel: 'Min',
            in: 'Masuk',
            out: 'Keluar',
            priceLog: 'Log Harga',
            editProduct: 'Edit Produk',
            deleteProduct: 'Padam Produk',
            deleteProductConfirm: 'Padam item ini?',
            viewFullImage: 'Klik untuk lihat imej penuh',
            bulkMode: 'Mod Pukal',
            exitBulkMode: 'Keluar',
            bulkProof: 'Bukti Dokumen',
            dragDropImage: 'Seret & lepas imej di sini',
            orClickToUpload: 'atau klik untuk muat naik',
            imageUploaded: 'Imej dimuat naik',
            changeImage: 'Tukar',
            bulkSelectProduct: 'Pilih produk...',
            bulkSearchProduct: 'Cari produk, SKU atau kategori...',
            bulkNoResults: 'Tiada produk dijumpai',
            qty: 'Ktn',
            add: 'Tambah',
            itemsSelected: 'item dipilih',
            confirmBulkOut: 'Sahkan Keluar Pukal',
            product: 'Produk',
            quantity: 'Kuantiti',
            unitLabel: 'Unit',
            selectItem: 'Pilih Item...',
            searchProductSKU: 'Cari produk, SKU atau kategori...',
            noProductFound: 'Tiada produk dijumpai',
            reason: 'Sebab',
            selectReason: 'Pilih sebab',
            dailyUsage: 'Kegunaan Harian',
            damaged: 'Rosak',
            lost: 'Hilang',
            returned: 'Dipulangkan',
            transfer: 'Pindahan',
            other: 'Lain-lain',
            invoiceRef: 'No. Invois / Tujuan',
            personInCharge: 'Person In Charge',
            picName: 'Nama Person In Charge',
            proofUpload: 'Muat Naik Resit/Bukti',
            proofRequired: 'Bukti Diperlukan',
            submit: 'Hantar',
            uploadImageOnly: 'Sila muat naik fail gambar sahaja',
            pleaseUploadProof: 'Sila muat naik bukti dokumen/gambar',
            insufficientStock: 'Stok tidak mencukupi',
            stockUpdated: 'Stok dikemaskini',
            noItemsAdded: 'Tiada item ditambah',
            pleaseSelectProduct: 'Sila pilih produk',
            invalidQty: 'Kuantiti tidak sah',
            bulkOutError: 'Ralat semasa keluar pukal',
            lowStockAlert: 'Stok Rendah',
            noProductsFound: 'Tiada produk dijumpai.',
            backToList: 'Kembali ke Senarai',
            addItem: 'Tambah Item',
            selectFromInventory: 'Pilih produk dari inventori anda',
            searchAndSelectItem: 'Cari & pilih item...',
            itemDetails: 'Butiran Item',
            noItemsYet: 'Tiada item ditambah lagi',
            selectFromDropdown: 'Pilih produk dari dropdown di atas',
            exitDetails: 'Keluar Butiran',
            additionalInfoOptional: 'Maklumat Tambahan (Pilihan)',
            totalItems: 'Jumlah Item',
            totalUnitsOut: 'Jumlah Unit Keluar',
            confirmStockIn: 'Sahkan Masuk',
            confirmStockOut: 'Sahkan Keluar',
            stockQtyManagedNote: 'Kuantiti stok dan lokasi diuruskan melalui tab',
            stockOpsTab: 'Operasi Stok',
            stockQtyManagedNote2: 'untuk memastikan jejak audit yang betul.',
            selectItemStockIn: 'Pilih Item untuk Stok Masuk',
            selectItemStockOut: 'Pilih Item untuk Stok Keluar',
            searchProductSKUShort: 'Cari nama produk atau SKU...',
            noItemFound: 'Tiada item dijumpai',
            priceChangedFrom: 'Harga diubah dari RM',
            priceChangedTo: 'ke RM',
        },
        // Purchase Orders
        po: {
            backToList: 'Kembali ke Senarai',
            newPO: 'PO Baru',
            editPO: 'Edit PO',
            itemDescription: 'Keterangan Item',
            sku: 'SKU',
            qtyLabel: 'Ktn',
            unitLabel: 'Unit',
            unitPrice: 'Harga Unit',
            amount: 'Jumlah',
            totalLabel: 'Jumlah',
            grandTotal: 'Jumlah Besar',
            addItem: 'Tambah Item',
            selectItem: 'Pilih Item...',
            searchProduct: 'Cari produk, SKU atau kategori...',
            noProductFound: 'Tiada produk dijumpai',
            supplier: 'Pembekal',
            selectSupplier: 'Pilih Pembekal',
            addNewSupplier: 'Tambah Pembekal Baru',
            paymentTerm: 'Terma Bayaran',
            notes: 'Nota',
            notesPlaceholder: 'Catatan tambahan atau arahan khas...',
            createPO: 'Cipta Pesanan',
            updatePO: 'Kemaskini Pesanan',
            deleteItem: 'Padam Item',
            allSuppliers: 'Semua Pembekal',
            allStatuses: 'Semua Status',
            incomplete: 'Belum Selesai',
            completed: 'Selesai',
            cancelled: 'Batal',
            allTime: 'Semua Masa',
            today: 'Hari Ini',
            yesterday: 'Semalam',
            thisWeek: 'Minggu Ini',
            lastWeek: 'Minggu Lepas',
            thisMonth: 'Bulan Ini',
            lastMonth: 'Bulan Lepas',
            customRange: 'Custom Range',
            listView: 'Paparan Senarai',
            calendarView: 'Paparan Kalendar',
            filterActive: 'penapis aktif',
            noItems: 'Tiada item',
            poNumber: 'No. PO',
            date: 'Tarikh',
            status: 'Status',
            items: 'item',
            cancelPO: 'Batal PO',
            cancelPOConfirm: "Adakah anda pasti mahu membatalkan PO ini? Status akan ditukar kepada 'Batal'.",
            deletePO: 'Padam PO',
            deletePOConfirm: 'Adakah anda pasti mahu memadam PO ini secara kekal? Tindakan ini tidak boleh dibatalkan.',
            downloadExcel: 'Muat Turun Excel',
            printPO: 'Cetak',
            receivePO: 'Terima Barang',
            receiveTitle: 'Pengesahan Penerimaan Barang',
            poCreated: 'Purchase Order Dicipta',
            poUpdated: 'Purchase Order Dikemaskini',
            poCompleted: 'Purchase Order Selesai',
            poCreateError: 'Ralat mencipta PO',
            poUpdateError: 'Ralat mengemaskini PO',
            poCancelError: 'Ralat membatalkan PO',
            poDeleteError: 'Ralat memadam PO',
            matched: 'Padan',
            matchedInfo: 'Semua kuantiti diterima padan dengan kuantiti pesanan. Tiada perbezaan ditemui.',
            discrepancyInfo: 'Perbezaan dikesan. Sila semak kuantiti di bawah.',
            received: 'Diterima',
            ordered: 'Dipesan',
            diff: 'Beza',
            confirmComplete: 'Sahkan & Selesaikan PO',
            systemQty: 'Sistem',
            actualQty: 'Sebenar',
            calToday: 'Hari Ini',
            calLastMonth: 'Bulan Lepas',
            calNextMonth: 'Bulan Depan',
            noPO: 'Tiada PO',
            noPOFound: 'Tiada purchase order dijumpai.',
            orderItems: 'Item Pesanan',
            totalColon: 'Jumlah:',
            orderCompletedDiscrepancy: 'Pesanan selesai dengan perbezaan kuantiti (discrepancy).',
            stockAddedSuccessfully: 'Stok telah ditambah ke inventori dengan jayanya.',
            receiveAllFullReset: 'Terima Semua Penuh (Reset)',
            clearAll: 'Kosongkan',
            confirmUpdateStock: 'Sahkan & Kemaskini Stok',
            errorLabel: 'Ralat',
            errorCancelPO: 'Ralat membatalkan PO',
            errorDeletePO: 'Ralat memadam PO',
            poNoLabel: 'No. PO:',
            dateLabel: 'Tarikh:',
            paymentTermLabel: 'Terma Bayaran:',
            statusLabel: 'Status:',
            priceRM: 'Harga (RM)',
        },
        // Stock Check / Audit
        stockCheck: {
            startNewAudit: 'Mula Audit Baru',
            auditorName: 'Nama Juruaudit',
            auditNotes: 'Nota Audit',
            searchItem: 'Cari Item atau SKU untuk disemak...',
            system: 'Sistem',
            actual: 'Sebenar',
            match: 'Padan',
            excess: 'Lebih',
            shortage: 'Kurang',
            totalItems: 'Jumlah Item',
            checked: 'Disemak',
            matched: 'Padan',
            discrepancies: 'Perbezaan',
            completeAudit: 'Tamatkan Audit',
            generateReport: 'Jana Laporan',
            auditStarted: 'Audit Dimulakan',
            auditCompleted: 'Audit Selesai & Stok Diselaraskan',
            auditError: 'Ralat',
            completeAuditError: 'Ralat semasa tamatkan audit',
            confirmEndAudit: 'Sahkan Tamat Audit',
            endAuditWarning: 'Item yang tidak disemak akan dikira sebagai "Padan" (tiada perubahan pada stok).',
            searchAuditor: 'Cari Juruaudit atau Nota...',
            allTime: 'Semua Masa',
            today: 'Hari Ini',
            yesterday: 'Semalam',
            thisWeek: 'Minggu Ini',
            lastWeek: 'Minggu Lepas',
            thisMonth: 'Bulan Ini',
            lastMonth: 'Bulan Lepas',
            customRange: 'Custom Range',
            inProgress: 'Sedang Berjalan',
            completed: 'SELESAI',
            complete: 'Selesai',
            auditProgress: 'Kemajuan Audit',
            progress: 'Kemajuan',
            continueAudit: 'Sambung Audit',
            auditStock: 'Audit Stok',
            confirm: 'Sahkan',
            allStatuses: 'Semua Status',
            noAuditFound: 'Tiada Audit Dijumpai',
            noStockAudit: 'Tiada Audit Stok',
            startNewAuditDesc: 'Mula audit stok baharu untuk menjejak inventori anda.',
            startNewAuditBtn: 'Mula Audit Baharu',
            completionDate: 'Tarikh Selesai',
            auditDate: 'Tarikh Audit',
            officerOnDuty: 'Nama Pegawai Bertugas',
            additionalNotes: 'Catatan tambahan...',
            starting: 'Memulakan...',
            startAuditBtn: 'Mula Audit',
            auditInfoNote: 'Sistem akan merekodkan baki stok semasa untuk perbandingan. Pastikan semua transaksi tertunggak telah selesai.',
            adjustmentWarning: 'Perhatian: Pelarasan Stok Akan Dibuat',
            allItemsMatch: 'Semua Item Padan',
            noAdjustmentNeeded: 'Tiada pelarasan stok diperlukan',
            confirmEndAuditBtn: 'Sahkan & Tamatkan Audit',
            auditStockReport: 'Laporan Audit Stok',
            variance: 'Beza',
            physical: 'Fizikal',
            adjustment: 'Pelarasan',
            needsAdjustment: 'Perlu Laras',
            itemsToAdjust: 'Item Yang Akan Diselaraskan',
            adjustmentDescription: 'Sistem akan melaraskan kuantiti stok bagi item-item yang berbeza. Tindakan ini tidak boleh dibatalkan.',
            auditNo: 'No. Audit',
            auditor: 'Juruaudit',
        },
        // History / Transactions
        history: {
            searchItemReason: 'Cari item, Sebab, User, atau PIC...',
            allTime: 'Semua Masa',
            today: 'Hari Ini',
            yesterday: 'Semalam',
            thisWeek: 'Minggu Ini',
            lastWeek: 'Minggu Lepas',
            thisMonth: 'Bulan Ini',
            lastMonth: 'Bulan Lepas',
            selectDateRange: 'Pilih Julat Tarikh',
            allTypes: 'Semua Jenis',
            stockIn: 'Stok Masuk',
            stockOut: 'Stok Keluar',
            adjustment: 'Pelarasan',
            transactionDetails: 'Butiran Transaksi',
            downloadReport: 'Muat Turun Laporan',
            burstReport: 'Laporan Burst',
            monthlyBurstReport: 'Laporan Burst Bulanan',
            viewProof: 'Lihat Bukti',
            noTransactions: 'Tiada transaksi dijumpai.',
            invoiceRef: 'Invois/Ref',
            pic: 'PIC',
            proof: 'Bukti',
            dateCol: 'Tarikh',
            typeCol: 'Jenis',
            userCol: 'Pengguna',
            noTransactionsFound: 'Tiada transaksi dijumpai',
            errorFetchingLog: 'Ralat mendapatkan log transaksi',
            errorFetchingDetail: 'Ralat mendapatkan butiran transaksi',
            dateTime: 'Tarikh & Masa',
            additionalInfoProof: 'Maklumat Tambahan & Bukti',
            picNameLabel: 'Nama PIC',
            supplierLabel: 'Pembekal: ',
            stockOutHeading: 'Stok Keluar',
            burstLimit: 'Had Burst',
            burstCount: 'Bilangan Burst',
            noBurstViolations: 'Tiada Pelanggaran Had Burst',
            allItemsWithinLimit: 'Semua item berada dalam had keluar bulanan yang ditetapkan.',
            selectMonth: 'PILIH BULAN',
            itemsExceededLimit: 'Item Melebihi Had',
            exceededLimit: 'Melebihi Had',
            percentage: 'Peratusan',
            stockIn: 'STOK MASUK',
            stockOut: 'STOK KELUAR',
            poReceived: 'PO DITERIMA',
            auditAdjustment: 'PELARASAN AUDIT',
            recordedBy: 'Direkod Oleh',
            picName: 'Nama PIC',
            contactNo: 'No. Hubungan',
            auditorLabel: 'Juruaudit: ',
            auditId: 'ID Audit: ',
            burstReportDownloaded: 'Laporan Burst dimuat turun',
            categoryCol: 'Kategori',
            transactionLog: 'Log Transaksi',
            burstReportTab: 'Laporan Burst Bulanan',
        },
        // Settings
        settings: {
            projectDetails: 'Butiran Ruang Kerja',
            skuManagement: 'Pengurusan SKU',
            supplierManagement: 'Pengurusan Pembekal',
            companyInfo: 'Maklumat Syarikat',
            companyName: 'Nama Syarikat',
            companySsm: 'No. SSM',
            companyPhone: 'Telefon',
            companyEmail: 'Emel',
            companyLogo: 'Logo Syarikat',
            uploadLogo: 'Muat Naik Logo',
            changeLogo: 'Tukar Logo',
            addressLine1: 'Alamat Baris 1',
            addressLine2: 'Alamat Baris 2 (Pilihan)',
            postcode: 'Poskod',
            state: 'Negeri',
            selectState: 'Pilih Negeri',
            warehouseInfo: 'Maklumat Gudang',
            warehouseName: 'Nama Gudang',
            warehousePIC: 'Person In Charge',
            warehouseAddress: 'Alamat Gudang',
            projectInfo: 'Maklumat Ruang Kerja',
            projectName: 'Nama Ruang Kerja',
            projectDesc: 'Keterangan Ruang Kerja',
            projectType: 'Jenis Ruang Kerja',
            saveChanges: 'Simpan Perubahan',
            saveConfirm: 'Adakah anda pasti mahu menyimpan butiran ruang kerja ini?',
            saveSuccess: 'Butiran ruang kerja berjaya dikemaskini',
            saveError: 'Ralat menyimpan butiran ruang kerja',
            deleteProject: 'Padam Ruang Kerja',
            deleteConfirmTitle: 'Pengesahan Akhir',
            deleteConfirmMsg: 'taip nama ruang kerja untuk mengesahkan pemadaman. Tindakan ini tidak boleh dibatalkan.',
            typeToConfirm: 'Taip nama ruang kerja untuk mengesahkan',
            editSupplier: 'Edit Pembekal',
            addSupplier: 'Tambah Pembekal',
            supplierName: 'Nama Pembekal',
            supplierPhone: 'Telefon',
            supplierEmail: 'Emel',
            supplierAddress: 'Alamat',
            supplierUpdated: 'Pembekal dikemaskini',
            supplierAdded: 'Pembekal ditambah',
            supplierError: 'Ralat menyimpan pembekal',
            categoryManagement: 'Pengurusan Kategori',
            addCategory: 'Tambah Kategori',
            categoryAdded: 'Kategori ditambah',
            categoryDeleted: 'Kategori dipadam',
            deleteCategory: 'Padam Kategori',
            deleteCategoryConfirm: 'Padam kategori',
            // Workspace Details page additions
            companyDetails: 'Butiran Syarikat',
            displayedOnInvoicePO: 'Akan dipaparkan pada invois dan PO.',
            registeredCompanyName: 'NAMA SYARIKAT BERDAFTAR',
            companyLogoLabel: 'LOGO SYARIKAT',
            logoDisplayedOnPDF: 'Logo akan dipaparkan pada PDF PO dan Laporan Audit Stok.',
            deleteCompanyLogo: 'Padam Logo Syarikat',
            confirmDeleteLogo: 'Adakah anda pasti mahu memadam logo syarikat ini?',
            logoDeleted: 'Logo syarikat dipadam',
            failedDeleteLogo: 'Gagal memadam logo',
            logoUpdated: 'Logo syarikat dikemas kini',
            failedUploadLogo: 'Gagal muat naik logo',
            formatMaxSize: 'Format: PNG, JPG, GIF (Maks 2MB)',
            recommendedSize: 'Disyorkan: 200x200px atau lebih tinggi',
            companySSMNo: 'NO. SSM SYARIKAT',
            officialPhone: 'NO. TELEFON RASMI',
            officialEmail: 'EMEL RASMI',
            websiteLabel: 'LAMAN WEB',
            mailingAddress: 'ALAMAT SURAT MENYURAT (SYARIKAT)',
            line2Optional: 'Baris 2 (Pilihan)',
            postcodeLabel: 'Poskod',
            warehouseInfoTitle: 'Maklumat Gudang',
            warehouseNameAddress: 'Nama dan alamat lokasi operasi/penghantaran.',
            warehouseNameLabel: 'NAMA GUDANG',
            warehousePICName: 'NAMA PIC GUDANG',
            picPhoneNo: 'NO. TELEFON PIC',
            picEmailLabel: 'EMEL PIC',
            warehouseDeliveryAddress: 'ALAMAT GUDANG (PENGHANTARAN)',
            companyMailingAddress: 'ALAMAT SURAT MENYURAT (SYARIKAT)',
            projectIdentity: 'Identiti Ruang Kerja',
            projectNameIcon: 'Nama ruang kerja dan ikon untuk dashboard.',
            projectNameLabel: 'NAMA RUANG KERJA',
            descriptionLabel: 'PENERANGAN',
            projectIconLabel: 'IKON RUANG KERJA',
            chooseIconDesc: 'Pilih ikon yang mewakili ruang kerja anda. Ikon ini akan dipaparkan di halaman utama.',
            saveProjectDetails: 'Simpan Butiran Ruang Kerja',
            imageTooLarge: 'Saiz gambar terlalu besar. Maksimum 2MB.',
            // SKU Management additions
            searchProductPlaceholder: 'Cari produk...',
            categoryBtn: 'Kategori',
            newProduct: 'Produk Baru',
            productCol: 'PRODUK',
            categoryCol: 'KATEGORI',
            priceCol: 'HARGA',
            stockCol: 'STOK',
            burstLimitMonthly: 'HAD BURST (BULANAN)',
            actionsCol: 'TINDAKAN',
            priceUp: 'Harga naik',
            priceDown: 'Harga turun',
            lowStockTooltip: 'Stok Rendah',
            priceLogTooltip: 'Log Harga',
            editProductTooltip: 'Edit Produk',
            deleteProductTooltip: 'Padam Produk',
            noProductsFound: 'Tiada produk dijumpai.',
            // Supplier Management additions
            companyNameCol: 'Nama Syarikat',
            picCol: 'PIC',
            contactCol: 'Hubungan',
            addressColHeader: 'Alamat',
            deleteConfirmQ: 'Padam?',
            deleteSupplierConfirm: 'Padam pembekal ini?',
            noSuppliers: 'Tiada pembekal.',
            emailLabel: 'Emel',
            updateBtn: 'Kemaskini',
            saveBtn: 'Simpan',
            // Category modal
            newCategoryPlaceholder: 'Kategori Baru...',
            addBtn: 'Tambah',
            noCategoriesYet: 'Tiada kategori.',
            deleteCategoryQ: 'Padam kategori',
            // Supplier modal
            picNameLabel: 'Nama PIC',
            picPhoneLabel: 'Telefon PIC',
            line1Placeholder: 'Baris 1',
            line2Placeholder: 'Baris 2 (Pilihan)',
            manageCategory: 'Urus Kategori',
        },
        // Auth
        auth: {
            login: 'Log Masuk',
            logout: 'Log Keluar',
            logoutConfirm: 'Adakah anda pasti mahu log keluar?',
            email: 'Alamat Emel',
            emailPlaceholder: 'nama@syarikat.com',
            password: 'Kata Laluan',
            rememberMe: 'Ingat saya',
            forgotPassword: 'Lupa kata laluan?',
            resetPassword: 'Reset Kata Laluan',
            resetYourPassword: 'Reset Kata Laluan Anda',
            sendVerificationCode: 'Hantar Kod Pengesahan',
            verificationCode: 'Kod Pengesahan',
            enterCode: 'Masukkan kod 6 digit',
            newPassword: 'Kata Laluan Baharu',
            backToLogin: 'Kembali ke log masuk',
            codeSent: 'Kod pengesahan telah dihantar ke e-mel anda. Sila semak peti masuk anda.',
            passwordReset: 'Kata laluan berjaya dikemas kini! Sila log masuk dengan kata laluan baharu.',
            loginFailed: 'Log Masuk Gagal',
            resetFailed: 'Reset Kata Laluan Gagal',
            networkError: 'Ralat rangkaian atau pelayan.',
            noResponse: 'Tiada respons dari pelayan. Sila semak sambungan internet.',
            serverError: 'Ralat Pelayan',
            subtitle: 'Sistem Pengurusan Inventori Pintar',
            userProfile: 'Profil Pengguna',
            language: 'Bahasa',
            fullName: 'Nama Penuh',
            yourPassword: 'Kata laluan anda',
            profileUpdated: 'Profil dikemaskini',
            userManual: 'Panduan Pengguna',
            userManualDesc: 'Buka manual lengkap penggunaan sistem (boleh cetak/simpan PDF)',
            // Profile modal additions
            uploadPhoto: 'Muat Naik Gambar',
            imageFormatMax: 'Format: JPG, PNG, GIF (Maks 2MB)',
            fullNameLabel: 'NAMA PENUH',
            emailAddressLabel: 'ALAMAT EMEL',
            emailCannotChange: 'Emel tidak boleh diubah',
            changePassword: 'Tukar Kata Laluan',
            newPasswordOptional: 'KATA LALUAN BARU (OPTIONAL)',
            leaveBlankPassword: 'Biarkan kosong jika tidak mahu menukar kata laluan',
            confirmPasswordLabel: 'SAHKAN KATA LALUAN',
            accessLevelLabel: 'TAHAP AKSES ANDA',
            superAdminGlobal: 'Super Admin (Global)',
            projectUser: 'Pengguna Ruang Kerja',
            cannotChangeAccess: 'Anda tidak boleh mengubah tahap akses anda sendiri',
            processing: 'Memproses...',
        },
        // Common
        common: {
            save: 'Simpan',
            cancel: 'Batal',
            delete: 'Padam',
            edit: 'Edit',
            search: 'Cari',
            add: 'Tambah',
            close: 'Tutup',
            confirm: 'Sahkan',
            last: 'Terakhir',
            previous: 'Sebelum',
            next: 'Seterusnya',
            yes: 'Ya',
            no: 'Tidak',
            loading: 'Memuatkan data...',
            error: 'Ralat',
            success: 'Berjaya',
            noData: 'Tiada data dijumpai',
            actions: 'Tindakan',
            name: 'Nama',
            created: 'Dicipta',
            from: 'Dari',
            to: 'Hingga',
            all: 'Semua',
            type: 'Jenis',
            print: 'Cetak',
            download: 'Muat Turun',
            deleteConfirm: 'Adakah anda pasti?',
            projectCreated: 'Ruang kerja dicipta',
            projectDeleted: 'Ruang kerja berjaya dipadam',
            projectDeleteError: 'Ralat memadam ruang kerja',
            productSaved: 'Produk disimpan',
            productSaveError: 'Ralat menyimpan produk',
            userCreated: 'Pengguna dicipta',
            userUpdated: 'Pengguna dikemaskini',
            userDeleted: 'Pengguna dipadam',
            deleteUser: 'Padam Pengguna',
            deleteUserConfirm: 'Adakah anda pasti mahu memadam pengguna ini?',
            mainWarehouse: 'Gudang Utama',
            yesConfirm: 'Ya, Sahkan',
            processing: 'Memproses...',
            reset: 'Reset',
            noDescription: 'Tiada keterangan ruang kerja.',
            errorVerifyingPassword: 'Ralat mengesahkan kata laluan',
            insufficientStockFor: 'Stok tidak mencukupi untuk',
        },
        // Workspace Selection
        projects: {
            welcome: 'Selamat Datang',
            selectProject: 'Pilih ruang kerja untuk mula mengurus inventori anda.',
            newProject: 'Ruang Kerja Baru',
            manageUsers: 'Urus Pengguna',
            userManagement: 'Pengurusan Pengguna',
            manageAccess: 'Urus akses dan peranan pengguna sistem',
            createFirstProject: 'Cipta Ruang Kerja Pertama',
            startManaging: 'Mula urus stok anda sekarang',
            noProjectsAssigned: 'Tiada Ruang Kerja Diberikan',
            contactSuperAdmin: 'Hubungi Super Admin untuk akses ruang kerja',
            createNewProject: 'Cipta Ruang Kerja Baru',
            briefDescription: 'Deskripsi ringkas ruang kerja...',
            createProject: 'Cipta Ruang Kerja',
            description: 'Keterangan',
            exampleWarehouse: 'Cth: Gudang Petaling Jaya',
        },
        // Reports / Excel / PDF
        reports: {
            generatedBy: 'Dijana oleh ENHIVE pada',
            generatedByMs: 'Generated by ENHIVE on',
            purchaseOrder: 'PURCHASE ORDER',
            vendorSupplier: 'VENDOR (SUPPLIER)',
            shipTo: 'SHIP TO',
            subtotal: 'SUBTOTAL',
            grandTotal: 'GRAND TOTAL (RM)',
            termsTitle: 'Terms & Conditions',
            term1: 'Goods once sold will not be taken back or exchanged',
            term2: 'Goods remain the property of the vendor till fully paid',
            term3: 'Delivery must be made within the time specified',
            term4Prefix: 'All disputes are subject to',
            term4Suffix: 'jurisdiction only',
            term5Prefix: 'Payment terms:',
            term5Default: '30 days from invoice date',
            computerGenerated: 'This is a computer-generated document. No signature is required.',
            notesInstructions: 'NOTES / INSTRUCTIONS',
            noAdditionalNotes: 'Tiada nota tambahan.',
            auditReportTitle: 'LAPORAN AUDIT STOK',
            auditNo: 'No. Audit',
            dateLabel: 'Tarikh',
            auditor: 'Juruaudit',
            statusLabel: 'Status',
            completedStatus: 'Selesai',
            inProgressStatus: 'Sedang Berjalan',
            totalItems: 'Jumlah Item',
            matchedLabel: 'Padan',
            discrepanciesLabel: 'Perbezaan',
            itemsList: 'Senarai Item',
            productName: 'Nama Produk',
            systemQty: 'Sistem',
            physicalQty: 'Fizikal',
            difference: 'Beza',
            auditNotes: 'Nota Audit',
            autoGenerated: 'Dokumen ini dijana secara automatik. Tiada tandatangan diperlukan.',
            burstLabel: 'Burst Count',
            noLabel: 'Bil',
            skuLabel: 'SKU',
            systemStockLabel: 'Stok Sistem',
            physicalStockLabel: 'Stok Fizikal',
            unitLabel: 'Unit',
            differenceLabel: 'Perbezaan',
            statusColLabel: 'Status',
        },
        // Item Modal
        itemModal: {
            updateProduct: 'Kemaskini Produk',
            addNewProduct: 'Tambah Produk Baru',
            productName: 'Nama Produk',
            sku: 'Kod SKU',
            category: 'Kategori',
            selectCategory: 'Pilih Kategori',
            unit: 'Unit',
            currentStock: 'Stok Semasa',
            minStock: 'Paras Stok Minimum',
            costPrice: 'Harga Kos (RM)',
            productImage: 'Gambar Produk',
        },
        // Stock Modal
        stockModal: {
            stockInTitle: 'Stok Masuk',
            stockOutTitle: 'Stok Keluar',
        },
        // User Management
        userMgmt: {
            title: 'Pengurusan Pengguna',
            subtitle: 'Urus akses dan peranan pengguna sistem',
            addUser: 'Tambah Pengguna',
            editUser: 'Edit Pengguna',
            isSuperAdmin: 'Super Admin',
            normalUser: 'Pengguna Biasa',
            superAdminAccess: 'Akses penuh ke semua ciri',
            limitedAccess: 'Akses berdasarkan kebenaran yang ditetapkan',
            permissions: 'Kebenaran',
            hideFinancials: 'Sembunyikan Data Kewangan',
            roleDescription: 'Keterangan Peranan',
            passwordPlaceholder: 'Kata laluan anda',
            // New additions
            editUserDetails: 'Edit Butiran Pengguna',
            createNewUser: 'Cipta Pengguna Baharu',
            uploadPhoto: 'Muat Naik Gambar',
            imageFormatMax: 'Format: JPG, PNG, GIF (Maks 2MB)',
            fullNameLabel: 'NAMA PENUH',
            emailAddressLabel: 'ALAMAT EMEL',
            passwordLabel: 'KATA LALUAN',
            keepExistingPassword: 'Biarkan kosong untuk mengekalkan kata laluan sedia ada',
            accessLevel: 'TAHAP AKSES',
            projectLevel: 'Ruang Kerja',
            selectProjectRole: 'Pilih ruang kerja dan peranan spesifik',
            fullAccessAllSystems: 'Akses penuh semua ruang kerja & sistem',
            superAdminFullAccess: 'Super Admin mempunyai akses penuh kepada:',
            selectProjectRoleLabel: 'PILIH RUANG KERJA & PERANAN',
            roleGuide: 'Panduan Peranan:',
            adminRoleDesc: 'Akses penuh kecuali pengurusan pengguna/ruang kerja',
            supervisorRoleDesc: 'Operasi harian tanpa tetapan ruang kerja',
            staffRoleDesc: 'Operasi Stok (Stok Keluar sahaja)',
            hideFinancialInfo: 'Sembunyikan Maklumat Kewangan',
            userCannotViewPrices: 'Pengguna tidak akan dapat melihat harga atau kos.',
            accountStatus: 'STATUS AKAUN',
            activeStatus: 'Aktif',
            inactiveStatus: 'Tidak Aktif',
            updateUser: 'Kemaskini Pengguna',
            createUser: 'Cipta Pengguna',
            noProjectsAvailable: 'Tiada ruang kerja tersedia',
            imageTooLarge: 'Saiz gambar terlalu besar. Maksimum 2MB.',
            createNewUserBtn: 'Cipta Pengguna Baharu',
            projectAccessCol: 'Akses Ruang Kerja',
            allProjectsGlobal: 'Semua Ruang Kerja (Global)',
            noAccess: 'Tiada akses',
            deleteTooltip: 'Padam',
            noUsersFound: 'Tiada pengguna dijumpai',
            clickCreateNewUser: 'Klik "Cipta Pengguna Baharu" untuk mula',
            // Role descriptions
            superAdminDesc: 'Akses penuh ke semua ruang kerja dan tetapan sistem',
            superAdminFeatures: 'Urus pengguna,Cipta/hapus ruang kerja,Akses semua modul,Lihat semua data kewangan',
            adminDesc: 'Akses penuh kepada modul ruang kerja, kecuali pengurusan pengguna dan ruang kerja',
            adminFeatures: 'Dashboard,Operasi Stok,PO,Audit Stok,Sejarah,Tetapan Ruang Kerja',
            supervisorDesc: 'Akses kepada operasi harian, tanpa tetapan ruang kerja',
            supervisorFeatures: 'Dashboard,Operasi Stok,PO,Audit Stok,Sejarah',
            staffDesc: 'Akses terhad kepada Operasi Stok sahaja (Stok Keluar)',
            staffFeatures: 'Operasi Stok (Stok Keluar sahaja)',
        },
        // Confirm modal
        confirmModal: {
            confirmAction: 'Sahkan Tindakan',
        },
        // Supplier modal fields
        supplierModal: {
            name: 'Nama Syarikat',
            contactPerson: 'Nama Pegawai',
            phone: 'Telefon',
            email: 'Emel',
            addressLine1: 'Alamat Baris 1',
            addressLine2: 'Alamat Baris 2',
            postcode: 'Poskod',
            state: 'Negeri',
            selectState: 'Pilih Negeri',
        },
        // Price Log
        priceLog: {
            title: 'Sejarah Harga',
            costPrice: 'Harga Kos',
            date: 'Tarikh',
            noData: 'Tiada sejarah harga tersedia',
            currentPrice: 'Harga Semasa: RM',
            priceChangeHistory: 'Sejarah Perubahan Harga',
            noPriceChanges: 'Tiada perubahan harga direkodkan',
        },
        // Receive PO Modal
        receivePOModal: {
            matchedMsg: 'Semua kuantiti diterima padan dengan kuantiti pesanan. Tiada perbezaan ditemui.',
            discrepancyMsg: 'Perbezaan dikesan. Sila semak kuantiti di bawah.',
        },
        // AI Insights
        aiInsights: {
            textCopied: 'Teks berjaya disalin!',
            failedToCopy: 'Gagal menyalin teks',
            projectLabel: 'Ruang Kerja:',
            dateLabel: 'Tarikh:',
            noContent: 'Tiada kandungan',
            noContentAvailable: 'Tiada kandungan tersedia.',
            copyBtn: 'Salin',
            closeBtn: 'Tutup',
        },
        // Delete Workspace Modal
        deleteProjectModal: {
            title: 'Hapus Ruang Kerja',
            warningMsg: 'Semua data inventori, transaksi, dan laporan akan dipadam selama-lamanya.',
            dataToBeDeleted: 'Data yang akan dipadam:',
            allProducts: 'Semua produk dan stok',
            purchaseOrders: 'Pesanan pembelian (PO)',
            transactionHistory: 'Sejarah transaksi',
            confirmWithPassword: 'Sahkan dengan memasukkan kata laluan anda:',
            deleteProjectBtn: 'Hapus Ruang Kerja',
        },
        // Bulk Confirm Modal
        bulkConfirm: {
            title: 'Sahkan Keluar Pukal',
            itemList: 'Senarai Item',
        },
    },
};

export const getTranslation = (language) => {
    const lang = translations[language] || translations.en;
    
    const t = (key) => {
        const keys = key.split('.');
        let value = lang;
        for (const k of keys) {
            value = value?.[k];
        }
        if (value === undefined) {
            // Fallback to English
            let fallback = translations.en;
            for (const k of keys) {
                fallback = fallback?.[k];
            }
            return fallback || key;
        }
        return value;
    };
    
    return t;
};

export default translations;
